import { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import * as actions from '../../../redux/actions';

// opportunity ที่ "ได้งาน" (WON) แล้วกดสร้างโครงการไปแล้วจะมี project_id ผูกไว้ (เขียนโดย
// useCreateProject.js ผ่าน linkOpportunityProject) — ดึงสรุปโครงการนั้นมาโชว์แทนปุ่ม
// "สร้างโครงการ" ใน StatusActionsCard ใช้ dispatch(actions.projectGet(id)) แบบเดียวกับ
// ProjectPopup.js/ProjectSingleDashboard.js (อ่านผลลัพธ์ตรงจาก dispatch ไม่ผูกกับ
// state.project ที่ใช้ร่วมกับหน้าอื่น ดู CLAUDE.md gotcha เรื่อง redux slice ทับกัน)
export function useLinkedProject(projectId) {
  const dispatch = useDispatch();
  const [project, setProject] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!projectId) {
      setProject(null);
      return undefined;
    }
    let cancelled = false;
    setLoading(true);
    dispatch(actions.projectGet(projectId))
      .then((data) => { if (!cancelled) setProject(data); })
      .catch(() => { if (!cancelled) setProject(null); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => {
      cancelled = true;
    };
  }, [dispatch, projectId]);

  return { project, loading };
}

export default useLinkedProject;
